export default __webpack_public_path__ + "alberta-cancel.cf97325f43a4ae5f59f6.svg";